<template>
  <div class="d-inline-flex pa-0 ma-0" v-if="!isSmaller" style="width: 100%;">
    <!-- <v-breadcrumbs
      class="pt-0 pb-1 px-0"
      :items="breadcrumbs"
      large
      style="flex-wrap: nowrap; overflow-x: auto; width: 85vw;"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>-->

    <div class="d-flex mr-auto text-h6 text-capitalize">{{ $route.name }}</div>

    <v-divider class="mx-3" vertical></v-divider>

    <div class="d-flex my-auto" style="width: 15vw;">
      <template v-if="onBranchStaff & !$store.state.vendors.vendorNotFound">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="openNewStaffDialog()">
          <v-icon left>mdi-account-plus</v-icon>
          <span class="text-capitalize">Add Staff</span>
        </v-btn>
      </template>

      <template v-else-if="onVendorBranches">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="openNewBranchDialog()">
          <v-icon left>mdi-source-branch-plus</v-icon>
          <span class="text-capitalize">Add Branch</span>
        </v-btn>
      </template>

      <template v-else-if="onBranchProducts & !$store.state.vendors.vendorNotFound">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="openNewProductDialog()">
          <v-icon left>mdi-tag-plus</v-icon>
          <span class="text-capitalize">Add Product</span>
        </v-btn>
      </template>

      <template v-else-if="onBranchOrders & !$store.state.vendors.vendorNotFound">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="makeNewOrder()">
          <v-icon left>mdi-file-document-edit</v-icon>
          <span class="text-capitalize">New Order</span>
        </v-btn>
      </template>

      <template v-else-if="onBranchProfitsVsCostsGroups & !$store.state.vendors.vendorNotFound">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="openNewGroupDialog()">
          <v-icon left>mdi-select-group</v-icon>
          <span class="text-capitalize">New Group</span>
        </v-btn>
      </template>

      <template v-else-if="onBranchExpensesGroups & !$store.state.vendors.vendorNotFound">
        <v-btn
          depressed
          class="primary darken-4 text-none mx-auto"
          @click="openNewExpensesGroupDialog()"
        >
          <v-icon left>mdi-select-group</v-icon>
          <span class="text-capitalize">New Expenses Group</span>
        </v-btn>
      </template>

      <template v-else-if="onBranchProfitsVsCostsGroup & !$store.state.vendors.vendorNotFound">
        <v-btn
          depressed
          class="primary darken-4 text-none mx-auto"
          @click="openAddGroupProductDialog()"
        >
          <v-icon left>mdi-tag-plus</v-icon>
          <span class="text-capitalize">Add Product</span>
        </v-btn>
      </template>

      <template v-else-if="onBranchExpensesGroup & !$store.state.vendors.vendorNotFound">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="openAddExpenseDialog()">
          <v-icon left>mdi-cash-minus</v-icon>
          <span class="text-capitalize">Add Expense</span>
        </v-btn>
      </template>

      <template v-if="onBranchContacts & !$store.state.vendors.vendorNotFound">
        <v-btn depressed class="primary darken-4 text-none mx-auto" @click="openNewContactDialog()">
          <v-icon left>mdi-account-plus</v-icon>
          <span class="text-capitalize">Add Contact</span>
        </v-btn>
      </template>
    </div>
  </div>

  <div v-else class="d-flex mr-auto text-h6 text-capitalize">{{ $route.name }}</div>

  <!-- <v-breadcrumbs
    v-else
    class="pt-0 pb-1 px-0"
    :items="breadcrumbs"
    large
    style="flex-wrap: nowrap; overflow-x: auto; width: 100%;"
  >
    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>-->
</template>

<script>
export default {
  name: "BreadCrumbs",
  data() {
    return {
      breadcrumbs: []
    };
  },

  methods: {
    openAddGroupProductDialog() {
      this.$store.commit("setAddGroupProductDialog", true);
    },

    openAddExpenseDialog() {
      this.$store.commit("setAddExpenseDialog", true);
    },

    openNewGroupDialog() {
      this.$store.commit("setNewGroupDialog", true);
    },

    openNewExpensesGroupDialog() {
      this.$store.commit("setNewExpensesGroupDialog", true);
    },

    openNewStaffDialog() {
      this.$store.commit("setNewStaffDialog", true);
    },

    openNewBranchDialog() {
      this.$store.commit("setNewBranchDialog", true);
    },

    openNewProductDialog() {
      this.$store.commit("setNewProductDialog", true);
    },

    openNewContactDialog() {
      this.$store.commit("setNewContactDialog", true);
    },

    makeNewOrder() {
      this.$store.dispatch("makeNewOrder");
    }
  },

  computed: {
    isSmaller() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs" || name === "sm") return true;
      else return false;
    },

    onBranchProducts() {
      if (this.$route.name === "products") {
        return this.$store.getters.isAuthorized;
      } else {
        return false;
      }
    },

    onBranchOrders() {
      if (this.$route.name === "orders")
        return this.$store.getters.isAuthorized2;
      else return false;
    },

    onBranchStaff() {
      if (this.$route.name === "staff") return this.$store.getters.isAuthorized;
      else return false;
    },

    onBranchProfitsVsCostsGroups() {
      if (this.$route.name === "profits-vs-costs-groups")
        return this.$store.getters.isAuthorized;
      else return false;
    },

    onBranchExpensesGroups() {
      if (this.$route.name === "expenses-groups")
        return this.$store.getters.isAuthorized;
      else return false;
    },

    onBranchProfitsVsCostsGroup() {
      if (this.$route.name === "profits-vs-costs-group")
        return this.$store.getters.isAuthorized;
      else return false;
    },

    onBranchExpensesGroup() {
      if (this.$route.name === "expenses-group")
        return this.$store.getters.isAuthorized;
      else return false;
    },

    onBranchContacts() {
      if (this.$route.name === "contacts")
        return this.$store.getters.isAuthorized;
      else return false;
    },

    onVendorBranches() {
      if (this.$route.name === "branches")
        return this.$store.getters.isAuthorizedVendor;
      else return false;
    }
  }
};
</script>

<style>
.v-application--is-ltr .v-banner__wrapper {
  padding-left: 0px;
}
.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
  padding-left: 0px;
}
</style>